var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeftActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(0%, 59.214783%, 27.058411%)",
    fillOpacity: 1,
    d: "M 13.710938 6 L 8 11.699219 L 13.707031 17.40625 L 15.121094 15.992188 L 10.832031 11.699219 L 15.121094 7.417969 Z M 13.710938 6 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftActive);
export default __webpack_public_path__ + "static/media/chevron-left-active.532aa9ce2fe5b771cac4d514ceebc5e9.svg";
export { ForwardRef as ReactComponent };